import {
  Tooltip2 as BlueprintTooltip,
  Tooltip2Props as BlueprintTooltipProps,
  Popover2InteractionKind,
} from '@blueprintjs/popover2';
import classNames from 'classnames';
import * as React from 'react';

export interface TooltipProps extends BlueprintTooltipProps {
  children?: React.ReactNode;
}

export const Tooltip: React.VFC<TooltipProps> = ({
  children,
  popoverClassName,
  ...tooltipProps
}) => (
  <BlueprintTooltip
    hoverCloseDelay={100}
    interactionKind={Popover2InteractionKind.HOVER}
    popoverClassName={classNames('sd-tooltip', popoverClassName)}
    portalContainer={
      (process.env.NODE_ENV === 'test' &&
        document.getElementById('vet-bones-root')) ||
      // istanbul ignore next
      undefined
    }
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...tooltipProps}
  >
    {
      // fragment is required since popover supports only having one child
    }
    <>{children}</>
  </BlueprintTooltip>
);
